import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductoserviceService } from './services/productoservice.service';
import { Product } from './interfaces/producto.interface';
import { Reporte, ReporteForValidation } from './interfaces/reporte.interface';
import { SimplifiedProduct } from './interfaces/simpleProduct';
import { DetalleReporte } from './interfaces/detalleReporte.interface';
import { EnviarCorreoService } from '../services/envio-mensaje';
import { months } from '../reporte/modal-ventas/assets/date';
import { computoUnidad, validarNumeros } from './utils/computo-unidades';
import Swal from 'sweetalert2';
import { convertValues } from './utils/conversor';
import { RegistroService } from '../registro.service';
import { TranslateService } from '@ngx-translate/core';
import { ReporteIndividualService } from './services/reporte-individual.service';
@Component({
    selector: 'app-reporte-ventas',
    templateUrl: './reporte-ventas.component.html',
    styleUrls: ['./reporte-ventas.component.css'],
})
export class ReporteVentasComponent implements OnInit {
    company: string;
    year: number;
    month: string;
    monthNumber: number;
    products: Product[];
    filteredProducts: Product[];
    reporte: Reporte;
    errors: any[];
    message;
    modalidadDecargue = 'Pendiente';
    enviar = false;
    presentaciones = [];
    searchTerm = '';
    perfilUsuario;
    userEnvio;
    currentCurrency = 'pesos';
    tipoMoneda = 'pesos';
    public cargaProductosCompletada = false;
    tipoMonedaMap = {
        pesos: '$',
        miles: 'K',
        millones: 'M',
        milesMillones: 'MM',
    };
    ultimoIdCreado;
    idReporte;
    reporteDetalleData;
    reporteDetallePeriodoAnteriorData: ReporteForValidation;
    constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly productService: ProductoserviceService,
        private readonly correo: EnviarCorreoService,
        private readonly router: Router,
        private readonly registroService: RegistroService,
        private readonly translate: TranslateService,
        private readonly estadoReporte: ReporteIndividualService
    ) {
        this.translate.setDefaultLang('es');
        this.translate.use('es');
    }

    ngOnInit() {
        const ultimoObjetoCreado: any =
            this.estadoReporte.existeRepoteGuardado();
        if (ultimoObjetoCreado) {
            this.ultimoIdCreado = ultimoObjetoCreado.id_reporte_guardado;
            const reporte = this.productService.getReporte(this.ultimoIdCreado);
            reporte.subscribe({
                next: (data) => {
                    this.reporteDetalleData = data;
                    this.year = this.reporteDetalleData.anio;
                    const mes = months.find(
                        (dato) =>
                            dato.number ===
                            Number(this.reporteDetalleData.periodo)
                    );
                    this.month = mes.name;
                    this.monthNumber = mes.number;
                },
                error: (error) => {
                    console.error('Error al cargar reporte', error);
                },
                complete: () => {
                    this.loadProducts();
                },
            });
        }
        this.activatedRoute.queryParams.subscribe((params) => {
            this.year = params['year'];
            this.month = params['month'];
            this.monthNumber = params['monthNumber'];
        });

        if (this.ultimoIdCreado === undefined) {
            this.loadProducts();
        }
    }

    onCurrencyChange(event: any) {
        const newCurrency = this.tipoMoneda;
        convertValues(this.products, this.currentCurrency, newCurrency);
        this.currentCurrency = newCurrency;
    }

    get currencySymbol(): string {
        return this.tipoMonedaMap[this.tipoMoneda];
    }
    //precarga de todos los productos con estado activo y presentacion activa
    async loadProducts() {
        try {
            const resultProducts: any[] = await (
                await this.productService.getProducts()
            ).toPromise();
            const productsToSort = [];
            resultProducts.forEach((product) => {
                product.presentaciones.forEach((presentacion) => {
                    const productCopy = { ...product };

                    if (
                        presentacion.estado === true &&
                        product.estado === true
                    ) {
                        /* productCopy.productoId= */
                        productCopy.tipoProducto = product.tipoProducto.nombre;
                        productCopy.nombrePresentacion =
                            presentacion.empaqueUnidadMedida.empaque?.nombre ||
                            'Nombre no disponible';
                        productCopy.cantidadPresentacion =
                            presentacion?.cantidad || 'Unidad no disponible';
                        productCopy.unidadPresentacion =
                            presentacion.empaqueUnidadMedida.unidadMedida
                                ?.nombre || 'Unidad no disponible';
                        productCopy.presentacionId = presentacion.id;
                        productCopy.id = presentacion.id;
                        productCopy.productoId = product.id;
                        // Verifica si la presentación ID existe en reporteDetalleData.detalles
                        if (this.ultimoIdCreado) {
                            const detalle =
                                this.reporteDetalleData.detalles?.find(
                                    (detalle) =>
                                        detalle.presentacionId ===
                                        presentacion.id
                                );
                            productCopy.id = detalle?.id || presentacion.id;
                            if (detalle !== undefined) {
                                // Asigna valores antes de imprimir
                                productCopy.precioVenta =
                                    detalle?.precioVenta || 0;
                                productCopy.cantidadUnidadVendida =
                                    detalle?.cantidadUnidadVendida || 0;
                                productCopy.volumenInventario =
                                    detalle?.volumenInventario || 0;
                                productCopy.valorUnitario =
                                    detalle?.valorUnitario || 0;
                            }
                        }
                        productsToSort.push(productCopy);
                    }
                });
            });
            // Ordena los productos alfabéticamente por 'tipoProducto' y luego numéricamente por 'numeroRegistroIca'
            this.products = productsToSort.sort((a, b) => {
                const tipoProductoComparison = a.tipoProducto.localeCompare(
                    b.tipoProducto
                );
                if (tipoProductoComparison !== 0) {
                    return tipoProductoComparison;
                }
                return a.numeroRegistroIca - b.numeroRegistroIca;
            });
        } catch (error) {
            console.error('Error al cargar productos', error);
        }
    }
    mostrarTexto() {
        this.translate
            .get('reporteIndividual.alertaAyuda')
            .subscribe((translatedText: string) => {
                Swal.fire('', translatedText, 'info');
            });
    }

    // envio y finalizacion de reporte
    async enviarReporte() {
        if (this.validateData(true)) {
            const reporteFinalizado = {
                estadoReporte: 'Finalizado',
            };
            try {
                //Obtener la información del reporte del periodo apto anterior
                const reportePeriodoAnterior = await this.productService
                    .getReportePeriodoAnterior(
                        Number(this.registroService.empresaSelected),
                        parseInt(`${this.year}`),
                        `${this.monthNumber}`
                    )
                    .toPromise();
                this.reporteDetallePeriodoAnteriorData = reportePeriodoAnterior;

                const resultado = await this.postReporteDetalle(true);
                if (!resultado) {
                    return;
                }
                const res = await this.productService
                    .FinalizarReporte(this.ultimoIdCreado, reporteFinalizado)
                    .toPromise();
                this.estadoReporte.actualizarArregloReportes();
                // Obtener el reporte detalle después de finalizar el reporte
                const reporte = await this.productService
                    .getReporte(this.ultimoIdCreado)
                    .toPromise();
                this.reporteDetalleData = reporte;

                // Enviar el correo solo después de obtener el reporte detalle
                await this.correo.enviarCorreo(this.reporteDetalleData);

                this.ultimoIdCreado = null;
                Swal.fire('', 'Reporte enviado con éxito', 'success').then(
                    (result) => {
                        if (result.isConfirmed) {
                            this.router.navigate(['/carga-consulta-reportes']);
                        }
                    }
                );
            } catch (error) {
                this.message = error;
            }
        }
    }
    //funcion para almacenar la informacion avanzada en el reporte
    async guardaInformacion() {
        if (!this.products || this.products.length === 0) {
            Swal.fire(
                '',
                'No es posible guardar el reporte. La empresa no tiene productos ni presentaciones registradas.',
                'warning'
            );
            return;
        }
        if (this.validateData(false) && !this.ultimoIdCreado) {
            this.modalidadDecargue = 'Pendiente';
            try {
                const respuestaDelServidor = await this.postProducts();
                this.estadoReporte.actualizarArregloReportes(
                    respuestaDelServidor
                );
                const ultimoObjetoCreado: any =
                    this.registroService.listaReportesGuardados.find(
                        (agenteVigilado) =>
                            agenteVigilado.idEmpresa ===
                            this.registroService.empresaSelected
                    );
                this.ultimoIdCreado = ultimoObjetoCreado.id_reporte_guardado;

                const guardadoExitoso = await this.postReporteDetalle();
            
                if (guardadoExitoso) {
                    Swal.fire('', 'Reporte guardado', 'success');
                    this.enviar = true;
                }
            } catch (error) {
                this.message = error;
            }
        } else if (this.validateData(false) && this.ultimoIdCreado) {
            try {
                const guardadoExitoso = await this.postReporteDetalle();
            
                if (guardadoExitoso) {
                    Swal.fire('', 'Reporte guardado', 'success');
                    this.enviar = true;
                }
            } catch (error) {
                this.message = error;
            }
        }
    }

    //inicialización del reporte
    async postProducts() {
        const idRepresentanteAgente = JSON.parse(
            localStorage.getItem('representanteAgenteVigilado')
        );
        if (!this.products || this.products.length === 0) {
            this.message = 'No hay datos para cargar.';
            return;
        }
        const reporte: Reporte = {
            agenteVigiladoId: Number(this.registroService.empresaSelected),
            estadoReporte: this.modalidadDecargue,
            modalidadCargue: 'Manual',
            representanteAgenteVigiladoId: idRepresentanteAgente.id,
            anio: parseInt(`${this.year}`),
            periodo: parseInt(`${this.monthNumber}`),
            observacion: 'Observaciones del reporte',
        };
        try {
            const respuestaDelServidor = await this.productService
                .loadSalesData(reporte)
                .toPromise();
            this.message = 'Los datos se cargaron correctamente.';
            return respuestaDelServidor;
        } catch (error) {
            throw error;
        }
    }

    async postReporteDetalle(validarCompras: boolean = false) {
        if (!this.products || this.products.length === 0) {
            this.message = 'No hay datos para cargar.';
            return;
        }
        if (!this.ultimoIdCreado) {
            console.error('Error: this.ultimoIdCreado no está definido');
            return;
        }

        if (validarCompras) {
            const validacion = this.validarProductosConInventarioAnterior();

            if (validacion.tieneError) {
                const result = await Swal.fire({
                    text: 'Se identificaron inconsistencias en los valores registrados en el reporte de ventas e inventarios. ¿Está seguro que desea continuar con el envío de la información?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, continuar',
                    cancelButtonText: 'No, cancelar',
                    confirmButtonColor: '#198754',
                    cancelButtonColor: '#6c757d',
                });

                if (!result.isConfirmed) {
                    return false;
                }
            }
        }

        const reporteDetalles: SimplifiedProduct[] = [];
        let error = false;

        const erroresProductos: string[] = [];
        const estaVacio = (valor: any) => valor === undefined || valor === null || valor === '';
        this.products.forEach((producto) => {
            const cantidadVendida = Number(producto.cantidadUnidadVendida) || 0;
            const precioVenta = Number(producto.precioVenta) || 0;
            error = true;

            //Salta los productos que no se han diligenciado
            if (
                estaVacio(producto.precioVenta) &&
                estaVacio(producto.cantidadUnidadVendida) &&
                estaVacio(producto.volumenInventario)
            ) {
                return;
            }

            if (
                (cantidadVendida === 0 && precioVenta > 0) ||
                (cantidadVendida > 0 && precioVenta === 0)
            ) {
                Swal.fire({
                    title: 'Error de validación',
                    text: `El producto ${producto.nombreComercial} tiene un valor inconsistente: Si la cantidad vendida es mayor a 0, el precio de venta debe ser mayor a 0 y viceversa.`,
                    icon: 'error',
                });
                throw `El producto ${producto.nombreComercial} tiene un valor inconsistente: Si la cantidad vendida es mayor a 0, el precio de venta debe ser mayor a 0 y viceversa.`;
            }

            // Verificar que todos los campos necesarios estén presentes y sean válidos
            if (
                !estaVacio(producto.precioVenta) &&
                !estaVacio(producto.cantidadUnidadVendida) &&
                !estaVacio(producto.volumenInventario) &&
                producto.valorUnitario !== undefined &&
                producto.presentacionId !== undefined
            ) {
                let precioVenta = producto.precioVenta
                    ? producto.precioVenta
                    : 0;
                const cantidadUnidadVendida = producto.cantidadUnidadVendida
                    ? producto.cantidadUnidadVendida
                    : 0;
                const volumenInventario = producto.volumenInventario
                    ? producto.volumenInventario
                    : 0;
                const valorUnitario = producto.valorUnitario
                    ? producto.valorUnitario
                    : 0;

                if (this.tipoMoneda === 'miles') {
                    precioVenta = precioVenta * 1000;
                } else if (this.tipoMoneda === 'millones') {
                    precioVenta = precioVenta * 1000000;
                } else if (this.tipoMoneda === 'milesMillones') {
                    precioVenta = precioVenta * 1000000000;
                }
                const detalle: SimplifiedProduct = {
                    ...(producto.id !== producto.presentacionId && {
                        id: producto.id,
                    }),
                    reporteId: this.ultimoIdCreado,
                    productoId: producto.productoId,
                    presentacionId: producto.presentacionId,
                    precioVenta: precioVenta.toString() || 0,
                    cantidadUnidadVendida:
                        cantidadUnidadVendida.toString() || 0,
                    volumenInventario: volumenInventario.toString() || 0,
                    valorUnitario: valorUnitario || 0,
                };
                reporteDetalles.push(detalle);
            } else {
                const camposFaltantes: string[] = [];

                if (estaVacio(producto.cantidadUnidadVendida)) {
                    camposFaltantes.push('Cantidad de unidades vendidas');
                }
                if (estaVacio(producto.volumenInventario)) {
                    camposFaltantes.push('Cantidad de unidades en inventario');
                }
                if (estaVacio(producto.precioVenta)) {
                    camposFaltantes.push('Valor ventas totales');
                }
                if (estaVacio(producto.valorUnitario)) {
                    camposFaltantes.push('Valor unitario');
                }
                if (estaVacio(producto.presentacionId)) {
                    camposFaltantes.push('Presentación');
                }

                if (camposFaltantes.length > 0) {
                    const nombreProducto = producto.nombreComercial || 'Producto Desconocido';
                    const nombrePresentacion = `${producto.nombrePresentacion || ''} de ${producto.cantidadPresentacion || ''} ${producto.unidadPresentacion || ''}`.trim();
                    const nombreCompleto = `${nombreProducto} - ${nombrePresentacion}`.trim();

                    const textoCampos = camposFaltantes.length === 1
                        ? `está pendiente registrar el campo: ${camposFaltantes[0]}`
                        : `están pendientes los campos: ${camposFaltantes.join(' y ')}`;

                    erroresProductos.push(`• Del producto <b>${nombreCompleto}</b> ${textoCampos}.`);
                }
            }
        });

        if (erroresProductos.length > 0) {
            Swal.fire({
                icon: 'info',
                title: 'Información incompleta',
                html: `
            <div style="text-align: left; font-size: 1rem;">
                <p>No es posible guardar el reporte. Para guardar debes diligenciar los campos de los productos registrados:</p>
                <div style="margin-top: 10px;">
                    ${erroresProductos.join('<br>')}
                </div>
            </div>
        `,
                confirmButtonText: 'OK',
                confirmButtonColor: 'var(--color-vP)',
                allowOutsideClick: false
            });

            return false;
        }
        
        const detalleReporte: DetalleReporte = {
            reporteId: this.ultimoIdCreado,
            detalles: reporteDetalles,
        };
        try {
            const response = await this.productService
                .loadDetalles(detalleReporte)
                .toPromise();
            if (this.modalidadDecargue === 'Finalizado') {
                //envio de notificacion del reporte
                this.estadoReporte.actualizarArregloReportes();
                this.ultimoIdCreado = null;
            }
            this.message = 'Los datos se cargaron correctamente.';
            return true;
        } catch (error) {
            console.error('Error al cargar detalles:', error);
            throw error;
        }
    }

    filterProducts() {
        if (this.searchTerm) {
            this.filteredProducts = this.products.filter((product) =>
                Object.values(product).some((value) =>
                    String(value)
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                )
            );
        } else {
            this.filteredProducts = null;
        }
    }

    validateData(enviar: boolean): boolean {
        const fieldsToValidate = enviar
            ? ['cantidadUnidadVendida', 'precioVenta', 'volumenInventario']
            : [];
        this.errors = [];

        for (const product of this.products) {
            for (const field of fieldsToValidate) {
                if (
                    product[field] === null ||
                    product[field] === undefined ||
                    product[field] === ''
                ) {
                    this.errors.push({
                        field,
                        product: product.tipoProducto,
                        message:
                            'Valor inválido, debe ingresar un valor numérico entero igual o mayor que 0',
                    });
                }
            }
        }
        return this.errors.length === 0;
    }

    computoUnidadValorU(event: any, field: string, product: any): void {
        computoUnidad(event, field, product, this.currentCurrency);
    }

    validarLimitesNumeros(event: any, tipoMoneda?: string): void {
        const inputValue = event.target.value;
        const valorValidado = validarNumeros(inputValue, tipoMoneda);
        event.target.value = valorValidado;
    }

    private validarProductosConInventarioAnterior(): {
        tieneError: boolean;
        productosConError: any[];
    } {
        const productosConError = [];

        for (const producto of this.products) {
            const ventas = Number(producto.cantidadUnidadVendida) || 0;
            const inventarioActual = Number(producto.volumenInventario) || 0;

            // Buscar inventario anterior para este producto
            let inventarioAnterior = 0;
            if (this.reporteDetallePeriodoAnteriorData) {
                const detalles =
                    this.reporteDetallePeriodoAnteriorData.detalles ||
                    this.reporteDetallePeriodoAnteriorData
                        .detallesComercializador;

                const detalleAnterior = detalles?.find(
                    (d: any) => d.productoId === producto.productoId
                );
                inventarioAnterior = detalleAnterior
                    ? Number(detalleAnterior.volumenInventario) || 0
                    : 0;
            }

            // Calcular compras
            const compras = ventas - inventarioAnterior + inventarioActual;

            let ratioComprasVentas = 0;
            if (ventas !== 0) {
                ratioComprasVentas = compras / ventas;
            }
            console.log(ratioComprasVentas);

            const tieneComprasNegativas = compras < 0;
            const tieneRatioAlto =
                ratioComprasVentas !== null && ratioComprasVentas > 3;

            if (tieneComprasNegativas || tieneRatioAlto) {
                // Construir mensaje de motivo (puede tener 1 o 2 errores)
                const motivos = [];
                if (tieneComprasNegativas) motivos.push('Compras negativas');
                if (tieneRatioAlto)
                    motivos.push(
                        `Cociente > 3 (${ratioComprasVentas.toFixed(2)})`
                    );

                productosConError.push({
                    nombreComercial: producto.nombreComercial,
                    ventas: ventas,
                    inventarioAnterior: inventarioAnterior,
                    inventarioActual: inventarioActual,
                    compras: compras,
                    ratio: ratioComprasVentas,
                    motivo: motivos.join(' y '),
                });
            }
        }

        return {
            tieneError: productosConError.length > 0,
            productosConError: productosConError,
        };
    }
}
